{
  "blocked": "Korrigieren Sie die markierten Änderungen, um sie zu speichern.",
  "discard": "Verwerfen",
  "edit": "{{text}} bearbeiten",
  "keep": "Fertig",
  "saving": "Wird gespeichert …",
  "undo": "Änderung an {{text}} zurücknehmen",
  "unsaved_one": "{{count}} ungespeicherte Änderung",
  "unsaved_other": "{{count}} ungespeicherte Änderungen"
}
